// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"0e6bf61f","739":"498fa489"}[chunkId] + ".chunk.js";
};